import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function NewsletterSection() {
  return (
    <section className="py-12 md:py-16">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 md:gap-10">
            {/* Latest Articles */}
            <div className="lg:col-span-3">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50">
                    影视资讯
                  </h2>
                  <p className="text-sm text-foreground-600 mt-1">最新影评与观影指南</p>
                </div>
              </div>
              <div className="space-y-4">
                {articles.slice(0, 3).map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="flex flex-col sm:flex-row gap-4 bg-background-100 rounded-lg p-4 border border-background-300/40 hover:border-primary-500/20 transition-all duration-300 cursor-pointer group"
                  >
                    <div className="w-full sm:w-40 h-24 rounded-md overflow-hidden flex-shrink-0">
                      <img
                        src={article.coverUrl}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <span className="text-xs text-accent-500 font-medium">{article.category}</span>
                      <h3 className="text-sm md:text-base font-semibold text-foreground-200 mt-1 mb-1 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                        {article.title}
                      </h3>
                      <p className="text-xs text-foreground-600 line-clamp-1">{article.excerpt}</p>
                      <div className="flex items-center gap-3 mt-2 text-xs text-foreground-700">
                        <span>{article.date}</span>
                        <span>{article.views.toLocaleString()} 次阅读</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>

            {/* Newsletter */}
            <div className="lg:col-span-2">
              <div className="bg-background-100 rounded-lg p-6 md:p-7 border border-background-300/40 sticky top-24">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100/70 mb-4">
                  <i className="ri-mail-send-fill text-primary-500 text-xl"></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold font-heading text-foreground-50 mb-2">
                  订阅影视资讯
                </h3>
                <p className="text-sm text-foreground-600 mb-5 leading-relaxed">
                  第一时间获取最新影片上线通知和独家影评，精彩不错过。
                </p>
                <form
                  id="newsletter-form"
                  data-readdy-form
                  action="https://readdy.ai/api/form/d9n3g3e8mbnljin59tcg"
                  method="POST"
                  className="space-y-3"
                >
                  <input
                    type="email"
                    name="email"
                    placeholder="请输入您的邮箱"
                    required
                    className="w-full px-4 py-2.5 bg-background-50 border border-background-300/60 rounded-md text-sm text-foreground-200 placeholder-secondary-400 outline-none focus:border-primary-500/60 transition-colors duration-200"
                  />
                  <div className="form-phone-alt-wrap">
                    <input
                      type="text"
                      name="phone_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full bg-primary-500 hover:bg-primary-600 text-background-50 py-2.5 rounded-md text-sm font-semibold transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    立即订阅
                  </button>
                </form>
                <p className="text-xs text-foreground-700 mt-3">
                  我们承诺不发送垃圾邮件，您可以随时取消订阅。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}